import { Box, Stack, Text } from '@chakra-ui/react'
import { faTrophy } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'
import { FONT_FAMILY } from '@/constants/constants'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'
import { PROGRESSION_DEFAULT } from '@/client/services/progression'

export default function UserPointsTotal({
  user,
  variant = 'small',
}: {
  user: Query
  variant?: 'big' | 'small'
}): JSX.Element {
  const progression = user(UserQ.progression) ?? PROGRESSION_DEFAULT
  return (
    <Stack direction="row" spacing="4px" align="center" textDecoration="none">
      <Box w={variant === 'big' ? '36px' : '20px'} fontSize={variant === 'big' ? '24px' : '14px'}>
        <FontAwesomeIcon icon={faTrophy} color={chakraTokenToVar('yellow.solid')} />
      </Box>
      <Text
        fontFamily={variant === 'big' ? FONT_FAMILY.default : FONT_FAMILY.heading}
        fontSize={variant === 'big' ? '20px' : '13px'}
        fontWeight="bold"
      >
        {progression.points ?? 0} SP
      </Text>
    </Stack>
  )
}
